import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { IntensitiesDataService, IntensitiesColumnsService } from '../../../services';
import { Intensity, IntensitiesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-intensity-details',
  templateUrl: './intensity-details.component.html',
  styleUrls: ['./intensity-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class IntensityDetailsComponent implements OnInit, OnDestroy {

  public intensity: Intensity = {};
  public intensities: Intensity[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private intensitiesDataService: IntensitiesDataService,
    private intensitiesColumnsService: IntensitiesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Intensity - Details');
        this.getIntensity(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.intensity !== 'undefined') {
      this.intensity = this.dynamicDialogConfig.data.intensity;
    }
    this.columns = this.intensitiesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getIntensity(id: number): void {
    this.isLoading = true;
    this.intensitiesDataService.getIntensity(id).subscribe((response: Intensity|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.intensity = response;
      }
    });
  }

  list() {
    this.router.navigate(['/intensities']);
  }

  add() {
    this.router.navigate(['/intensities/add']);
  }

  edit() {
    this.router.navigate(['/intensities/edit/' + this.intensity.id]);
  }

}
@Component({
  selector: 'app-intensity-details',
  templateUrl: './intensity-details.component.html',
  styleUrls: ['./intensity-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogIntensityDetailsComponent extends IntensityDetailsComponent {
}

